/**
 * @typedef {object} PageHelpTopic
 * @property {string} key
 * @property {string} screenLabel
 * @property {string} [purpose]
 * @property {string[]} [actions]
 * @property {string[]} [checklist]
 * @property {string[]} [commonMistakes]
 * @property {string} [warning]
 * @property {string} [nextStep]
 * @property {string[]} [usefulButtons]
 */

/**
 * @typedef {object} PageHelpContext
 * @property {string} [screenId]
 * @property {string} [sectionId]
 * @property {Record<string, string>} [params]
 */

const FALLBACK_TOPIC = /** @type {PageHelpTopic} */ ({
  key: "default",
  screenLabel: "Cette page",
  purpose: "Consultez l'aide contextuelle pour savoir quoi faire sur cet écran.",
  actions: ["Lisez les sections ci-dessous", "Suivez les étapes recommandées"],
  nextStep: "Revenez à votre tâche principale une fois informé.",
});

/**
 * @param {PageHelpContext} ctx
 * @param {Record<string, PageHelpTopic>} registry
 * @param {PageHelpTopic} [fallback]
 * @returns {PageHelpTopic}
 */
export function resolvePageHelpTopic(ctx, registry, fallback = FALLBACK_TOPIC) {
  if (!ctx?.screenId) return fallback;
  const direct = registry[ctx.screenId];
  if (direct) return direct;
  const composite = ctx.sectionId ? registry[`${ctx.screenId}:${ctx.sectionId}`] : null;
  return composite || fallback;
}
